function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderGuideNavActive = function SvgOrderGuideNavActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.082 29.845C22.54 33.73 6.077 25.601 5.074 20.907c-1.003-4.694 8.427-.294 16.542-8.261 8.115-7.968 17.037-18.999 18.798-8.051 1.562 9.708-.79 21.367-9.332 25.25Z",
    fill: props.accentFill,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.55 5 3.569 7.24 7.981 1.17-5.775 5.633L31.688 27l-7.138-3.76L17.412 27l1.363-7.958L13 13.41l7.981-1.168L24.55 5Z",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 16.1h6.8m-6.8 3.3h4.6",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round"
  }));
};
export default SvgOrderGuideNavActive;